import { cva } from 'class-variance-authority'

export const tooltipContentStyles = cva(
  `
    overflow-hidden 
    rounded-lg
    border-1
    border-neutral-200
    bg-neutral-0
    p-2
    text-sm 
    text-popover-foreground 
    shadow-[0px_4px_6px_-1px_rgba(0,0,0,0.10),0px_2px_4px_-1px_rgba(0,0,0,0.06)]
    animate-in 
    fade-in-0 
    zoom-in-95 
    whitespace-normal 
    max-w-xs
    z-9000
    data-[state=closed]:animate-out 
    data-[state=closed]:fade-out-0 
    data-[state=closed]:zoom-out-95 
    data-[side=bottom]:slide-in-from-top-2 
    data-[side=left]:slide-in-from-right-2 
    data-[side=right]:slide-in-from-left-2 
    data-[side=top]:slide-in-from-bottom-2
  `
)
